import {
    AuthorizationList,
    CanAccess,
} from "../../../components/template/authorization/Authorization";
import { RiDeleteBin5Fill } from "react-icons/ri";
import { BiEditAlt } from "react-icons/bi";
import { Button } from "antd";

export const initFilterInput = {
    searchName: "",
    page: 1,
    pageSize: 10,
    transactionStartDate: null,
    transactionEndDate: null,
    sortingField: "",
    sortingOrder: "",
};

export const addPengembalianData = {
    gadai_id: "",
    sbg: "",
    sbg_2: "",
    ktpPenerima: "",
    ktpNasabah: ""
};


export const accType = [
    { label: "Diterima oleh nasabah", value: true },
];


export const renderColumns = (handleEdit, handleDetail, handleUbah) => {
    return [
        {
            dataIndex: "tanggal_kirim",
            key: "tanggal_kirim",
            backend_key: "delivery_date",
            title: "Tanggal & Waktu Kirim",
            sorter: true,
        },
        {
            dataIndex: "nama_nasabah",
            key: "nama_nasabah",
            title: "Nama Nasabah",
        },
        {
            dataIndex: "nama_kurir",
            key: "nama_kurir",
            title: "Nama Kurir",
        },
        {
            dataIndex: "no_telp_nasabah",
            key: "no_telp_nasabah",
            title: "No. Telepon Nasabah",
        },
        {
            dataIndex: "no_telp_kurir",
            key: "no_telp_kurir",
            title: "No. Telepon Kurir",
        },
        {
            dataIndex: "barang_jaminan",
            key: "barang_jaminan",
            title: "Barang Jaminan ",
        },
        {
            dataIndex: "lokasi",
            key: "lokasi",
            title: "Lokasi Barang",
        },
        {
            dataIndex: "lokasi_kirim",
            key: "lokasi_kirim",
            title: "Lokasi Kirim",
        },
        {
            dataIndex: "status",
            key: "status",
            title: "Status",
            render: (text) => (
                <div
                    style={{
                        textAlign: "left",
                        color: "#2C465C",
                        fontWeight: "bold"
                    }}
                >
                    {text}
                </div>
            ),
        },
        {
            dataIndex: "action",
            key: "action",
            title: "Aksi",
            width: "10%",
            render: (_, record) =>
            (
                <div div className="d-flex flex-column" >
                    {(record.kondisi === "done") ?
                        <>
                            <div className="mr-2 mb-2">
                                <Button
                                    variant="primary"
                                    className="btn-action btn-default font-weight-semi-bold border-2C465C"
                                    onClick={() => handleEdit(record)}
                                    style={{ width: "122px" }}
                                >
                                    Detail
                                </Button>
                            </div>
                        </>
                        :
                        <>
                            <CanAccess
                                role={AuthorizationList.update_scheduled_delivery_gadai}
                                yes={
                                    <div className="mr-2 mb-2">
                                        <Button
                                            variant="primary"
                                            className="btn-action btn-detail"
                                            onClick={() => handleDetail(record)}
                                        >
                                            Tandai Selesai
                                        </Button>
                                    </div>}
                            />
                            <CanAccess
                                role={AuthorizationList.update_delivery_gadai}
                                yes={
                                    <div className="mr-2 mb-2">

                                        <Button
                                            variant="primary"
                                            className="btn-action btn-default font-weight-semi-bold border-2C465C"
                                            onClick={() => handleUbah(record)}
                                            style={{ width: "122px" }}
                                        >
                                            Ubah Jadwal
                                        </Button>
                                    </div>
                                } 
                                />
                        </>
                    }
                </div >
            ),
        },
    ];
};
